// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1D40w","content":"ManualTimeModal_content__3SfFz"};